export default function fetchNewRegister(body) {
    return fetch(process.env.VUE_APP_API_ORIGIN + '/api/newRegister', {
        method: 'POST',
        body,
    });
}